import { Button, Dialog, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import { RootState } from '../../../../reducers';
import { setPhotoFile, setPhotoFileName, uploadSkinPhoto } from '../../../../store/assessment.slice';
import { useAppDispatch } from '../../../../store/store';
import { useParams } from 'react-router-dom';

interface UploadPhotoDialogProps {
    open: boolean;
    onClose: () => void;
}

const UploadPhotoDialog: React.FC<UploadPhotoDialogProps> = ({ open, onClose }) => {
    const dispatch = useAppDispatch();
    const params = useParams();
    const { photoFile, photoFileName } = useSelector((state: RootState) => state.assessment);

    const handleAddPhoto = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files[0]) {
            dispatch(setPhotoFile(event.target.files[0]));
        }
    };

    const handleUploadPhoto = () => {
        if (photoFile) {
            dispatch(uploadSkinPhoto(photoFile, params.memberId));
            onClose();
        }
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Upload Photo</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mb={2} alignItems={'flex-start'} py={2}>
                    <TextField
                        autoFocus
                        size="small"
                        id="file-name"
                        label="File Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={photoFileName}
                        onChange={(e) => dispatch(setPhotoFileName(e.target.value))}
                    />
                    <Button variant="contained" component="label">
                        Select File <input type="file" hidden onChange={handleAddPhoto} />
                    </Button>
                    {photoFile && (
                        <Typography variant="subtitle1" fontStyle={'italic'}>
                            {photoFile.name}
                        </Typography>
                    )}
                </Stack>
            </DialogContent>
            <Stack direction={'row'} spacing={2} p={2}>
                <Button onClick={handleUploadPhoto} variant="contained" sx={{ minWidth: '200px' }}>
                    Ok
                </Button>
                <Button onClick={onClose} variant="outlined" sx={{ minWidth: '200px' }}>
                    Cancel
                </Button>
            </Stack>
        </Dialog>
    );
};

export default UploadPhotoDialog;
